module.exports = __webpack_public_path__ + "img/laos.97c46d9a.svg";